import { Component, OnInit, ViewChild } from '@angular/core';
import { CommonService } from '../../core/service/common-service/common.service';
import { ToastrService } from 'ngx-toastr';
import { WorkshopData } from './workshopData';
import { MatPaginator, MatSort, MatTableDataSource, MatOption } from '@angular/material';
import { SelectionModel } from '@angular/cdk/collections';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { element } from 'protractor';


export interface PeriodicElement {
  Checked: boolean;
  WorkshopName: string;
  WorkshopCode: number;
  WorkshopAddress: string;
}

@Component({
  selector: 'app-uam',
  templateUrl: './uam.component.html',
  styleUrls: ['./uam.component.scss']
})

export class UamComponent implements OnInit {
  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;
  @ViewChild(MatSort, { static: true }) sort: MatSort;
  @ViewChild('allSelected', { static: true }) private allSelected: MatOption;

  uamForm: FormGroup;
  spinner: boolean;
  userId: string;
  displayedColumns: string[] = ['Select', 'WorkshopCode', 'WorkshopName', 'WorkshopAddress'];
  searchUserID: string;
  workshopLength: number = 0;
  sizePage: number;
  userDetails: any;
  submitted: boolean = false;
  checkDetails: any;
  userName: string = '';
  emailId: string = '';
  contactNumber: string = '';
  defaultDropDown = <any>[];
  dealerCompany = <any>[];
  roleValue: any;
  dataSource: any;
  selection: any;
  verticalValue: any;
  cardShow: boolean = false;
  checkboxState: boolean = false;
  regionValue: any;
  dealerCompanyValue = <any>[];
  selectedRole: any = '';
  selectedVertical: string = '';
  selectedRegion: string = '';
  selectedDealerCompany: string;
  selectedWorkshopCode: any[] = [];
  selectedWorkshop: any[] = [];
  selectedDealer:any;
  delearCompanyList: string[] = [];
  delearCompanyListCopy: string[] = [];
  dealerCode: string[] = [];

  status: any[] = [
    { filterId: 'true', filterData: 'Active' },
    { filterId: 'false', filterData: 'Inactive' },
  ];

  constructor(private commonService: CommonService, private toastr: ToastrService, private fb: FormBuilder, ) { }

  ngOnInit() {
    this.userId = localStorage.getItem('userId');
    this.getDefaultDropDown();
    if (localStorage.getItem('workshopPageSize') != null || localStorage.getItem('workshopPageSize') != undefined) {
      let sizePage = Number(localStorage.getItem('workshopPageSize'));
      this.sizePage = (sizePage && sizePage != NaN) ? sizePage : 10;
    } else {
      this.sizePage = 10;
    }

    this.buildUamForm();
  }

  /**
  * Name: buildUamForm
  * purpose: To create uam data form
  */
  buildUamForm(): void {
    this.uamForm = this.fb.group({
      userName: [this.userName, Validators.required],
      userEmail: [this.emailId, [Validators.required, Validators.email]],
      userNumber: [this.contactNumber, [Validators.minLength(10), Validators.maxLength(10)]],
      userStatus: [this.status],
      userRole: [this.selectedRole],
      userVertical: [this.selectedVertical],
      userRegion: [this.selectedRegion],
      userDealerCompany: [''],
      selectedDealer:['']
    });
  }

  /**
  * Name: hasUamDataError
  * purpose: To check if uam form has any error
  * @param {any} control - form control
  * @return {boolean} flag to determine if form is valid.
  */
  hasUamDataError(control: any): boolean {
    return (
      control &&
      (this.submitted || control.touched || control.dirty) &&
      !control.valid
    );
  }

  /**
  * Name: getUserDetails
  * purpose: To get cre uam data form
  */
  getUserDetails(): void {
    this.spinner = true;
    this.commonService.getDetails(this.userId, this.searchUserID)
      .subscribe(res => {
        if (res["responseCode"] == 0) {
          this.checkDetails = res['responseData'];
          this.userName = res['responseData'].userdetails.username;
          this.emailId = res['responseData'].userdetails.emailId;
          this.contactNumber = res['responseData'].userdetails.contactNo;
          this.selectedRole = res['responseData'].role[0].filterId;
          this.status = res['responseData'].userdetails.status;
          this.selectedVertical = res['responseData'].vertical[0].filterId;
          this.selectedRegion = (res['responseData'].region.length != 0 ? res['responseData'].region[0].filterId : '');
          this.selectedDealerCompany = (res['responseData'].dealerCompany.length ? res['responseData'].dealerCompany[0].filterId : '');
          this.selectedWorkshopCode = [];
          if (res['responseData'].workShopDetails) {
            res['responseData'].workShopDetails.forEach(element => {
              element.checked = true;
              this.selectedWorkshopCode.push(element.workshopCode);
            });
          }

          this.selectedWorkshop = res['responseData'].workShopDetails;
          this.dataSource = new MatTableDataSource<WorkshopData>(res['responseData'].workShopDetails);
          const initialSelection = res['responseData'].workShopDetails;
          const allowMultiSelect = true;
          this.selection = new SelectionModel<WorkshopData>(allowMultiSelect, initialSelection);
          this.workshopLength = res['responseData'].workShopDetails && res['responseData'].workShopDetails.length ? res['responseData'].workShopDetails.length : 0;
          this.dataSource.paginator = this.paginator;

          this.buildUamForm();
          this.cardShow = true;
        } else {
          this.clear(false);
          this.buildUamForm();
          this.cardShow = true;
          this.toastr.info(res['message'], "Info");
        }
        this.spinner = false;
      }, err => {
        this.clear(true);
        this.spinner = false;
        this.cardShow = false;
        this.toastr.error("Something went wrong, Please try again.", "Error");
      });
  }

  /** Whether the number of selected elements matches the total number of rows. */
  isAllSelected() {
    if (this.dataSource && this.dataSource.data) {
      const numSelected = this.selection.selected.length;
      const numRows = this.dataSource.data.length;
      return numSelected === numRows;
    }
  }

  /** Selects all rows if they are not all selected; otherwise clear selection. */
  masterToggle() {
    if (this.dataSource && this.dataSource.data) {
      if (this.isAllSelected()) {
        this.dataSource.data.forEach(row => {
          this.selectedWorkshopCode = this.selectedWorkshopCode.filter(item => item != row.workshopCode);
        });
        this.selection.clear();
      } else {
        this.dataSource.data.forEach(row => {
          this.selection.select(row);
          let checkSelection = this.selectedWorkshopCode.indexOf(row.workshopCode);
          if (checkSelection < 0) {
            this.selectedWorkshopCode.push(row.workshopCode);
          }
        });
      }
    }
  }

  /**
  * Name: onChange
  * @param {any} element - checkbox element data
  * purpose: To select workshop code
  */
  onChange(element: any): void {
    let checkSelection = this.selection.selected.filter(item => item.workshopCode == element.workshopCode);

    if (checkSelection.length) {
      this.selectedWorkshopCode.push(element.workshopCode);
    } else {
      this.selectedWorkshopCode = this.selectedWorkshopCode.filter(item => item != element.workshopCode);
    }
  }

  /**
  * Name: clear
  * @param {boolean} searchClear - search clear flag
  * purpose: To clear form data
  */
  clear(searchClear: boolean) {
    if (searchClear) {
      this.searchUserID = '';
      this.cardShow = false;
    }
    this.userName = '';
    this.emailId = '';
    this.contactNumber = '';
    this.selectedRole = '';
    this.selectedVertical = '';
    this.selectedRegion = '';
    this.selectedDealerCompany = '';
    this.dataSource = '';
    this.status = [
      { filterId: 'true', filterData: 'Active' },
      { filterId: 'false', filterData: 'Inactive' },
    ];
    if (this.uamForm) {
      this.uamForm.reset();
    }
    this.selectedWorkshopCode = [];
    this.selectedWorkshop = [];
    this.workshopLength = 0;
  }

  /**
  * Name: getDefaultDropDown
  * purpose: To get Default DropDown data
  */
  getDefaultDropDown(): void {
    this.commonService.getDefaultDropDown(this.userId)
      .subscribe(res => {
        if (res['responseCode'] == 0) {
          this.defaultDropDown = res;
          this.roleValue = this.defaultDropDown['responseData'].role;
          this.verticalValue = this.defaultDropDown['responseData'].vertical;
          this.regionValue = this.defaultDropDown['responseData'].region;
          this.dealerCompanyValue = this.defaultDropDown['responseData'].dealerCompany;
          this.dealerCompanyValue.forEach(element => {
            this.delearCompanyList.push(element.filterId);
          })
          this.delearCompanyListCopy = this.delearCompanyList;
        } else {
          this.toastr.error(res['message'], "Error");
        }
        this.spinner = false;
      }, err => {
        this.spinner = false;
        this.toastr.error("Something went wrong, Please try again.", "Error");
      });
  }

  /**
  * Name: selectDropDown
  * @param {string} region - selected region
  * purpose: To get dealer company data
  */
  selectDropDown(region: string): void {
    this.delearCompanyList = [];
    this.spinner = true;
    this.commonService.getDealerCompany(this.userId, region).subscribe(res => {
      if (res['responseCode'] == 0) {
        this.uamForm.controls['userDealerCompany'].setValue("");
        this.dealerCompany = res;
        this.dealerCompanyValue = this.dealerCompany['responseData'];
        this.dealerCompanyValue.forEach(element => {
          this.delearCompanyList.push(element.filterId);
        });
        this.delearCompanyListCopy = this.delearCompanyList;
      } else {
        this.toastr.error(res['message'], "Error");
      }
      this.spinner = false;
    }, err => {
      this.spinner = false;
      this.toastr.error("Something went wrong, Please try again.", "Error");
    });
  }

  /**
  * Name: saveUserData
  * purpose: To save updated info
  */
  saveUserData(): void {
    this.spinner = true;
    let f = this.uamForm;
    this.submitted = true;
    if (f.valid) {
      const userJson: any = {};
      userJson.userId = this.searchUserID;
      userJson.username = f.value.userName || '';
      userJson.email = f.value.userEmail || '';
      userJson.contactNo = f.value.userNumber || '';
      userJson.workshopCode = '';

      //this.selectedWorkshopCode = f.value.userDealerCompany;
      this.selectedWorkshopCode.forEach((element, index) => {
        if (index == 0) {
          userJson.workshopCode = element;
        } else if(element != 0) {
          userJson.workshopCode = userJson.workshopCode + "#" + element;
        }
      });

      userJson.isActive = f.value.userStatus || '';
      if (userJson.isActive == true) {
        userJson.isActive = "Y"
      } else {
        userJson.isActive = "N"
      }
      userJson.role = f.value.userRole || '';
      userJson.veticalId = f.value.userVertical || '';
      this.commonService.saveUserData(userJson).subscribe(data => {
        if (data['responseCode'] == 0) {
          this.toastr.success(data['message'], "Success");
          this.clear(true);
        } else {
          this.toastr.error(data['message'], "Error");
        }
        this.spinner = false;
      }, err => {
        this.spinner = false;
        this.toastr.error("Something went wrong, Please try again.", "Error");
      });
    }
  }

  /**
  * Name: tosslePerOne
  * purpose: To select/remove all data in workshop drop down
  */
  tosslePerOne() {
    if (this.allSelected.selected) {
      this.allSelected.deselect();
      return false;
    }

    if (this.uamForm.controls.userDealerCompany.value.length == this.delearCompanyList.length) {
      this.allSelected.select();
    }
  }

  /**
  * Name: toggleAllSelection
  * purpose: To select/remove all data in workshop drop down
  */
  toggleAllSelection(): void {
    if (this.allSelected.selected) {
      this.uamForm.controls.userDealerCompany.patchValue([...this.delearCompanyList, 0]);
    } else {
      this.uamForm.controls.userDealerCompany.patchValue([]);
    }
  }

  /**
  * Name: getExportExcel
  * purpose: To download excel report
  */
  getExportExcel(): void {
    this.spinner = true;
    let time = new Date().getTime();
    let fileName = "VECV_Service Reminder Module_User_Role_Master_" + time;
    this.commonService.getExportExcel()
      .subscribe(fileData => {
        this.spinner = false;
        if (fileData) {
          const blob: any = new Blob([fileData], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
          let link = document.createElement("a");
          if (link.download !== undefined) {
            let url = URL.createObjectURL(blob);
            link.setAttribute("href", url);
            link.setAttribute("download", fileName);
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
          }
        }
      }, err => {
        this.spinner = false;
      });
  }

  /**
  * Name: getWorkshopDetails
  * @param {string} selectedRegion - selected region
  * @param {string} selectedDealerCompany - selected region
  * purpose: To get dealer workshop data
  */
  getWorkshopDetails(selectedRegion: string, selectedDealerCompany: string): void {
    if (this.allSelected.selected || !selectedDealerCompany) {
      this.selectedDealerCompany = 'ALL';
    } else {
      this.selectedDealerCompany = selectedDealerCompany;
    }

    if (!selectedRegion) {
      selectedRegion = 'ALL';
    }

    this.commonService.getWorkshop(this.userId, selectedRegion, this.selectedDealerCompany)
      .subscribe(res => {
        if (res['responseCode'] == 0) {
          let selectedSection = [];
          res['responseData'].forEach(element => {
            element.checked = false;
            this.selectedWorkshop.forEach(workshopData => {
              if (element.workshopCode == workshopData.workshopCode) {
                element.checked = true;
              }
            });

            this.selectedWorkshopCode.forEach(workshopCode => {
              if (element.workshopCode == workshopCode) {
                element.checked = true;
                selectedSection.push(element);
              }
            });
          });

          this.dataSource = new MatTableDataSource<WorkshopData>(res['responseData']);
          const initialSelection = selectedSection;
          const allowMultiSelect = true;
          this.selection = new SelectionModel<WorkshopData>(allowMultiSelect, initialSelection);
          this.sort.direction = '';
          this.dataSource.sort = this.sort;
          this.workshopLength = res['responseData'].length;
          this.dataSource.paginator = this.paginator;
        } else {
          this.toastr.error(res['message'], "Error");
        }
        this.spinner = false;
      }, err => {
        this.spinner = false;
        this.toastr.error("Something went wrong, Please try again.", "Error");
      });
  }

  onKey() : void {
    this.delearCompanyList = this.delearCompanyListCopy;
    this.dealerCode = [];
    this.selectedDealer = this.uamForm.controls.selectedDealer.value;
    this.selectedDealer = this.selectedDealer.toString();
    this.dealerCode = this.delearCompanyList.filter(item =>
      item.includes(this.selectedDealer.toLowerCase())
    );
    if(this.dealerCode.length > 0){
      this.closeInput();
    }
    this.delearCompanyList = [];
    this.delearCompanyList = this.dealerCode;
  }

  closeInput() : void {
    if(this.dealerCode.length == 0) {
     //this.selectedDealer = '';
     this.uamForm.controls['selectedDealer'].setValue("");
     this.delearCompanyList = this.delearCompanyListCopy;
    }
   }
}
